import { render } from "./EnquiryFormUploadControls.vue?vue&type=template&id=4f219cc7&scoped=true"
import script from "./EnquiryFormUploadControls.vue?vue&type=script&lang=js"
export * from "./EnquiryFormUploadControls.vue?vue&type=script&lang=js"

import "./EnquiryFormUploadControls.vue?vue&type=style&index=0&id=4f219cc7&scoped=true&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f219cc7"]])

export default __exports__